import type Metadata from './Metadata';
import type { Image3DPageData } from './sources';
import { ImageLikeSource, SourceType } from './sources';
import type { Pixel } from './Unit';
import type Unit from './Unit';

type TabData = {
  scoreUrl: string;
  svgImage : string;
  pixelUnit: Unit<Pixel>;
  width: Pixel;
  height: Pixel;
  pages? :Image3DPageData[];
  /** additional info */
  metadata : Metadata;
  name?:string;
  source?:string;
  isLinear:boolean
};

export default class Tab extends ImageLikeSource implements Readonly<TabData> {
  readonly scoreUrl: string;

  readonly svgImage: string;
  /* api:AlphatabAPI
  api.score
  api.render()
  setting:Settings */

  protected constructor(parsed: TabData) {
    super({
      type: parsed.isLinear ? SourceType.TabLinear : SourceType.Tab,
      pixelUnit: parsed.pixelUnit,
      width: parsed.width,
      height: parsed.height,
      name: parsed.name,
      source: parsed.source,
      pages: parsed.pages,
      isLinear: parsed.isLinear,
      metadata: parsed.metadata,
    });
    this.scoreUrl = parsed.scoreUrl;
    this.svgImage = parsed.svgImage;
  }

  scaled(scale: number): Tab {
    const data = { ...this };
    return new Tab({
      ...data,
      width: data.width * scale,
      pixelUnit: data.pixelUnit.getScaled(scale),
    });
  }
}
